import {createContext, useContext} from 'react';
import {HeaderStateProps} from './types';

export const HeaderStateContext = createContext<HeaderStateProps | undefined>(undefined);

export const useHeaderState = (): HeaderStateProps => {
    const context = useContext(HeaderStateContext);

    if (!context) {
        throw new Error('useHeaderState must be used with in the Header');
    }

    return context;
};
